import { FC, useState, useEffect } from 'react';
import { ConfigProvider, Form, Tooltip } from 'antd';
import { FormikProvider, FormikProps } from 'formik';
import cn from 'classnames';

import { Button, Checkbox, FormikCheckboxGroup, Icon, Text } from 'shared/components/ui';
import { SearchSelect } from 'features/search/components';
import { useGetCountriesQuery, useGetLocationsQuery } from 'services';
import { SeniorityEnum } from 'shared/generated-models';
import { SearchFormParams } from 'features/search/models';
import { AdaptiveDevices, formIsEmpty, getAdaptiveDevice } from 'shared/utils';
import { SearchParams } from 'shared/generated-models';

import styles from './index.module.scss';

export const PeopleFilters = ({formik}: {formik: FormikProps<SearchFormParams>}) => {
	const device = getAdaptiveDevice();

	const isSmallDevice = device === AdaptiveDevices.MOBILE || device === AdaptiveDevices.TABLET;
	const tooltipPlacement = isSmallDevice ? 'top' : 'right';

	return (
		<ConfigProvider
			theme={{
				components: {
					Tooltip: {
						paddingSM: 0,
						paddingXS: 0,
						borderRadius: 2,
						colorBgDefault: '#f8f8f8'
					}
				}
			}}>
			<div className={styles.container}>
				<FormikProvider value={formik}>
					<Form layout="vertical" className={styles.form}>
						<div>
							<div className={styles.field}>
								<SearchSelect
									label="City or state"
									name="locations"
									useQuery={useGetLocationsQuery}
									placeholder="Enter City or state"
								/>
							</div>
							<div className={styles.field}>
								<SearchSelect
									label="Country"
									name="countries"
									useQuery={useGetCountriesQuery}
									placeholder="Enter Country"
								/>
							</div>
							<div className={styles.field}>
								<FormikCheckboxGroup
									label={<Text variant="inter/15/medium">Seniority</Text>}
									name="seniority">
									<Checkbox value={SeniorityEnum.SENIOR}>Senior</Checkbox>
									<Checkbox value={SeniorityEnum.MIDDLE}>Middle</Checkbox>
									<Checkbox value={SeniorityEnum.JUNIOR}>Junior</Checkbox>
									<div className={styles.rockstar}>
										<Checkbox value={SeniorityEnum.ROCK_STAR}>
											<span className={styles.rockstarLabel}>Rock Star</span>
										</Checkbox>
										<Tooltip
											arrow={false}
											title={
												<div className={styles.tooltip}>
													<Text color="dark_green">
														Rock stars are famous experts in their areas, such as Dan
														Abramov or Vitalik Buterin.
													</Text>
												</div>
											}
											placement={tooltipPlacement}
											overlayClassName={styles.labelTooltip}>
											<Icon icon="info" className={styles.labelIcon} />
										</Tooltip>
									</div>
								</FormikCheckboxGroup>
							</div>
						</div>
					</Form>
				</FormikProvider>
			</div>
		</ConfigProvider>
	);
};
